<template>
  <div class="project-card-trials-steps">
    <div
      class="project-card-trials-step"
      v-for="(trial, exIndex) in trialList"
      :key="trial.id+ '-' +exIndex"
      :class="[trial.status]"
      v-tooltip="{ content: trial.name + ' (' + trial.status + ')' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCardTrialsSteps',
  props: ['trialList']
}
</script>

<style lang="stylus" scoped>
.project-card-trials-steps
  align-items: center
  display: flex
  min-height 5px
  .project-card-trials-step
    background-color: $mystic
    flex: 1 1 0
    height: 5px
    opacity: 0.8

    &:not(:last-child)
      margin-right: 5px

    &:hover
      opacity: 1

    &.ready
      background-color: $trial-ready
    &.running
      background-color: $trial-running
    &.submitted
      background-color: $trial-submitted
    &.paused
      background-color: $trial-paused
    &.finished
      background-color: $trial-finished
    &.aborted
      background-color: $trial-aborted
    &.cancelled
      background-color: $trial-cancelled
    &.failed
      background-color: $trial-failed

</style>